import {
  NGENIUS_DEPOSIT,
  NGENIUS_DEPOSIT_SUCCESS,
  NGENIUS_DEPOSIT_FAILURE,
} from "../actionTypes";

export const ngeniusDeposit = (payload) => ({
  type: NGENIUS_DEPOSIT,
  payload,
});

export const ngeniusDepositSuccess = (payload) => ({
  type: NGENIUS_DEPOSIT_SUCCESS,
  payload,
});

export const ngeniusDepositFailure = () => ({
  type: NGENIUS_DEPOSIT_FAILURE,
});
